
<template style="overflow: hidden;">
  <div style="overflow: hidden;"> 
    <!-- class="bg-img" -->
    <v-layout class="pt-3" row wrap style="overflow: hidden; height: 100vh; background-color: white;">
      <v-flex class="" md6 sm6 xs6 style="align-items: center; justify-content: center;">
        <div class="pl-2 pt-5">
          <img src="images/login-banner.jpg" style="overflow: hidden; margin-top:2%; width: 70%; float: right" />
        </div>
      </v-flex>
      <v-flex md6 sm6 xs6>
        <v-form class="container" ref="loginForm" lazy-validation @submit.prevent="submit">
          <v-progress-linear :indeterminate="processBar" class="my-0" :height="height"
            :background-opacity="opacity"></v-progress-linear>

          <!-- <img src="https://i.imgur.com/nrwVfvo.png" style="width: 300px;" class="logo" /> -->

          <div class="form-area">
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <div class="heading-text" style="color: #2196F3">
                  Syndicate Login
                </div>
              </v-flex>
              <v-flex md12 sm12 xs12>
                <div id="form-textfields">
                  <v-text-field v-show="!session_user" v-model="login.email" id="email" type="email" label="Email"
                    placeholder="Username/Email" required :rules="[v => !!v || 'email or username required']" autofocus
                    prepend-inner-icon="person"></v-text-field>

                  <v-text-field v-show="session_user" v-model="session_user" id="email" type="email" label="Email"
                    placeholder="Username/Email" required :rules="[v => !!v || 'email or username required']" autofocus
                    prepend-inner-icon="person" readonly clearable @click:clear="forgetRememberedUser"></v-text-field>
                </div>
              </v-flex>
              <v-flex md12 sm12 xs12>
                <div id="form-textfields">
                  <v-text-field v-model="login.password" :error-messages="errors" id="password"
                    :rules="[v => !!v || 'password is required']" type="password" label="Password"
                    v-on:keyup.enter="loginUser()" placeholder="************" required
                    prepend-inner-icon="lock"></v-text-field>
                </div>
              </v-flex>

              <v-flex md12 sm12 xs12>
                <vue-recaptcha sitekey="6LcJ9dEcAAAAAOfDDMMxdfwx0gFaYs6vjhyfts-v" :loadRecaptchaScript="true"
                  ref="recaptcha" type="invisible" @verify="onCaptchaVerified" @expired="onCaptchaExpired">
                </vue-recaptcha>
              </v-flex>
              <v-flex md6 sm12 xs12>
                <div id="remember-me">
                  <v-checkbox v-model="remember_me" label="Remember me" color="success" hide-details style="
                  margin-top: 0px !important;
                  padding-top: 0px !important;
                ">
                  </v-checkbox>
                </div>
              </v-flex>
              <v-flex md6 sm6>
                <div style="text-align: right; font-weight: bold;">
                  <a class @click="dialog = true">Forgot password?</a>
                </div>
              </v-flex>
              <v-flex md12 sm12 xs12>
                <v-btn block color="#4caf50 !important" class="btn btn-default white--text" id="submit_btn" primary
                  ref="loginButton" style="background-color: #1d6db9;
                  color: #fff;
                  box-shadow: none;
                  border-radius: 10px;
                  height: 40px;
                  margin-top: 25px;" 
                  :disabled="login_btn_status || !validateCaptcha"
                  @click="loginUser()"><b>Sign in</b></v-btn>
              </v-flex>
              <v-flex md12 sm12 xs12>
                <font face="Arial, Helvetica, sans-serif" size="2" color="#4db3a4">
                  <strong style="font-family: Arial, Helvetica, sans-serif; color: #4db3a4;">
                  <a href="#1" target="_blank" style="color: #4db3a4; text-decoration: none;">Customer support</a>
                  </strong></font>
                  <br>
                  <font face="Arial, Helvetica, sans-serif" size="2" color="#96a5b5">
                  <span style="font-family: Arial, Helvetica, sans-serif; color: #96a5b5;">
                    
                    Email: accounting@lendwizely.com
                    
                  </span></font>	
                <div class="arr">
                  &copy; 2022 All Rights Reserved
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
    
    <v-dialog v-model="dialog" v-if="dialog" width="500">
      <v-card>
        <v-card-title class="subheading grey lighten-2" primary-title>Reset Password</v-card-title>
        <v-flex>
          <v-text-field class="px-3" id="email" type="email" label="Email"
            v-model="login.email"
            placeholder="please enter your email to reset your password" required
            prepend-inner-icon="person"></v-text-field>
        </v-flex>
        <div id="errorContent"></div>
        <br />
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="#1976d2 !important" class="btn btn-default white--text" @click="dialog = false" text>Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#1976d2 !important" class="btn btn-default white--text" @click="sendEmail" :loading="send_email_loader" text id="btn_send_email">Send Me
            Email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import { URL } from '../../env'
import { config } from '../../config'
import moment from 'moment'
import { EventBus } from '../main.js';
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: { 'vue-recaptcha': VueRecaptcha },
  data() {
    return {
      send_email_loader: false,
      ip: null,
      login_btn_status: false,
      tiktik: null,
      date: moment(60 * 10 * 1000),
      errors: [],
      dialog: false,
      opacity: 0,
      height: 4,
      processBar: false,
      remember_me: false,
      session_user: null,
      login: {
        email: '',
        password: '',
        recaptcha: '',
      },
      setinterval: null,
      loadingPage: true,
      validateCaptcha: false
    };
  },
  computed: {
    time() {
      return this.date.format('mm:ss');
    }
  },
  mounted() {
    this.checkRememberSessionUser()
    this.checkLoginAttemptIfExists()
    this.logoutEventBusListener()
    this.onCaptchaExpired()
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val && val.user_email != undefined) {
          this.login.email = val.user_email;
          axios.get(`${URL}/api/checkSyndicateUserExistance/${val.user_email}`).then(resp => {
            if (resp.data.length === 0) {
              this.errors.push('This user is not a syndicate User');
            }
          });
        }
      },
      immediate: true
    },
    time() {
      this.$nextTick(() => {
        if (moment(this.date).format('mm') == 10 && moment(this.date).format('ss') == 0) {
          this.errors = []
        } else {
          this.errors = []
          this.errors[0] = 'Too many login attempts. Please try again after ' + this.time + ' sec'
        }
      })
    }
  },
  methods: {
    onCaptchaVerified: function (recaptchaToken) {
      this.processBar = false
      this.login.recaptcha = recaptchaToken
      this.validateCaptcha = true
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    async checkRememberSessionUser() {
      let remembered = null
      try { remembered = JSON.parse(localStorage.getItem("remember_me")) } catch (e) { remembered = null }
      if (!remembered || !remembered.token) return
      // The tenant header is normally resolved during login; restore it for this lookup.
      if (remembered.tenant) sessionStorage.setItem("X-TENANT", remembered.tenant)
      try {
        const response = await axios.get(`${URL}/api/session_user/${remembered.token}`);
        if (response.data && response.data.email) {
          this.login.email = response.data.email
          this.session_user = response.data.email.replace(/\w(?=(?:\W*\w){6})/g, "*");
          this.remember_me = true
          return
        }
      } catch (e) {
        // token expired or unknown: fall through and forget it
      }
      this.forgetRememberedUser()
    },
    forgetRememberedUser() {
      localStorage.removeItem("remember_me")
      this.session_user = null
      this.login.email = ''
    },
    logoutEventBusListener() {
      EventBus.$on("logoutEvent", (status) => {
        this.autoLogOutFunction()
      });
    },
    checkLoginAttemptIfExists() {
      if (localStorage.getItem('startTime') !== null && localStorage.getItem('login_attempts') > 3) {
        let locked_email = localStorage.getItem('email_locked')
        if (locked_email != null) {
          let locked_user = null
          axios.get(`${URL}/user/user_locked/` + locked_email).then(res => {
            if (res.data.length > 0 && res.data[0].login_attempts_status == 0) {
              locked_user = res.data[0]
              this.stopLoginAttemptInterval()
            }
          })
          if (locked_user && locked_user.login_attempts_status == 0)
            return;
        }
        let then = moment(localStorage.getItem('startTime'));
        let now = moment();
        let sec = moment.duration(now.diff(then)).asSeconds();
        let intervalTime = moment(60 * 10 * 1000)
        this.date = moment(intervalTime.subtract(parseInt(sec), 'seconds'))
        this.login_btn_status = true
        this.startLoginAttemptTimer()
      }
    },
    startLoginAttemptTimer() {
      this.tiktik = setInterval(() => {
        this.date = moment(this.date.subtract(1, 'seconds'))
        if (moment(this.date).format('mm') == 0 && moment(this.date).format('ss') < 1) {
          this.date = moment(60 * 10 * 1000)
          this.stopLoginAttemptInterval()
        }
      }, 1000);
    },
    stopLoginAttemptInterval() {
      this.errors = []
      this.login_btn_status = false
      localStorage.removeItem('email_locked');
      localStorage.removeItem('login_attempts')
      localStorage.removeItem('startTime')
      this.lockUnlockUser(0)
      clearInterval(this.tiktik);
    },
    autoLogOutFunction() {
      this.initialTimestamp();
      this.timeChecker();
    },
    initialTimestamp() {
      var timeStamp = new Date();
      localStorage.setItem("lastTimeStamp", timeStamp);
    },
    timeChecker() {
      let app = this;
      this.setinterval = setInterval(function () {
        var storedTimeStamp = localStorage.getItem("lastTimeStamp");
        app.timeCompare(storedTimeStamp);
      }, 3000);
    },
    timeCompare(timeString) {
      let app = this;
      var maxMinutes = 0.5 * 15 // * 2; // means (1min * 60 * 2) = 2 hours //GREATER THEN 1440 MIN OR 24 HOURS.
      var currentTime = new Date();
      var pastTime = new Date(timeString);
      var timeDiff = currentTime - pastTime;
      var minPast = Math.floor(timeDiff / 60000);
      if (timeString) {
        if (minPast >= maxMinutes) {
          EventBus.$emit('logOffDialog', 'open_dialog');
          clearInterval(this.setinterval)
        } else {
        }
      }
    },
    lockUnlockUser(status) {
      axios.post(`${URL}/user/user_locked`, {
        email: localStorage.getItem('email_locked'),
        login_attempts_status: status
      })
    },
    // randomStr(len, arr) {
    //   var ans = '';
    //   for (var i = len; i > 0; i--) {
    //     ans += 
    //       arr[Math.floor(Math.random() * arr.length)];
    //   }
    //   return ans;
    // },
    async sendEmail() {
        this.send_email_loader = true
        // await this.$store
        //   .dispatch("auth/sendResetLink", {
        //     email: this.email
        //   })
        await axios.post(`${URL}/user/send_reset_link`, {
          email: this.login.email
        })
          .then(response => {
            this.send_email_loader = false
            if(response && response.data && response.data.success){
              if(response.data.success){
                alert("Password reset link has been sent to your email, Please check your email to proceed");
                this.dialog = false;
                document.getElementById("btn_send_email").style.display = "block";
              } else {
                if (response.data.message == "not exist") {
                  document.getElementById("errorContent").innerHTML = "<p style='color:red'>Your Email does not exist in our system</p>";
                  document.getElementById("btn_send_email").style.display = "none";
                } else {
                  document.getElementById("errorContent").innerHTML = "<p style='color:green'>Your Email is registered in our system</p>";
                  document.getElementById("btn_send_email").style.display = "block";
                }
              }
            } 
            // else{
            //   if(response.includes("Error: Request failed with status code 429")){
            //     document.getElementById("errorContent").innerHTML = "<p style='color:red'>Too many login attempts.</p>";
            //     document.getElementById("btn_send_email").style.display = "none";
            //   }
            // }
          })
          .catch(err => {
            if(err && err.response && err.response.status == 429){
              document.getElementById("errorContent").innerHTML = "<p style='color:red'>Too many login attempts.</p>";
            }
            this.send_email_loader = false
            console.log(err)
          });
      // }
    },
    async loginUser() {
      sessionStorage.removeItem("X-TENANT");
      sessionStorage.removeItem("BASE_URL");
      let app = this
      let _payload = {
        username: this.login.email,
        password: this.login.password,
        grant_type: "password",
        client_id: config.clientId,
        client_secret: config.clientSecret,
        scope: ""
      };
      app.processBar = true
      let access_token = null
      const tenants = await axios.post(`${URL}/api/non-tenant/log-in`, {
        username: this.login.email,
        password: this.login.password,
      });
      if(!(tenants.data && tenants.data.success)) {
        this.errors.push(tenants.data.message);
      }
      if(tenants.data.length >0) {
        if(tenants.data.length == 1) {
          sessionStorage.setItem("X-TENANT", tenants.data[0].id);
          sessionStorage.setItem("BASE_URL", tenants.data[0].domain.domain);
        }
      } else {
        this.errors.push('This user has multiple accounts');
        app.processBar = false
        return
      }
      // sessionStorage.setItem("X-TENANT", "2023317087");

      
      // sessionStorage.setItem("X-TENANT", '2023317087');
      // sessionStorage.setItem("X-TENANT", '6f4c4abb-ebad-4bec-ad9e-0cc75020ccb0');


      // let url = `http://${tenants.data[0].domain.domain}:8000/oauth/token`
      let response_auth = await axios.post(`${URL}/api/non-tenant/oauth/token`, _payload).catch(err => {
        if (err == 'Error: Request failed with status code 401') {
          let login_attempts = (localStorage.getItem('login_attempts') != null) ? parseInt(localStorage.getItem('login_attempts')) + 1 : 1
          localStorage.setItem('login_attempts', login_attempts)
          if (localStorage.getItem('startTime') == null && login_attempts > 3) {
            let startTime = moment();
            localStorage.setItem('startTime', startTime);
            this.login_btn_status = true
            this.startLoginAttemptTimer()
            this.errors.push('Too many login attempts. Please try again after ' + this.time + ' sec');
            // save login attempt status in users table
            localStorage.setItem('email_locked', this.login.email);
            this.lockUnlockUser(1)
            // end
          } else {
            this.errors.push('The user credentials were incorrect');
          }
        } else {
          this.errors.push('The user credentials were incorrect');
        }
        app.processBar = false
      })
      const response = await axios.post(`${URL}/api/syndicate_login/${this.login.email}`, {
        ...this.login,
        remember_me: this.remember_me
      })

      // var remember_me = $("#hdnSession").data('remember_me');

      // alert(remember_me);
      if (response.data.length > 0 && response.data[0].role == "syndication") {
        this.onCaptchaExpired()
        if (response.data[0].terminated_user == 1) {
          return alert('Account is closed, please contact admin.');
        }
        if (this.remember_me && response.data[0].token) {
          localStorage.setItem("remember_me", JSON.stringify({ token: response.data[0].token, tenant: sessionStorage.getItem("X-TENANT") }))
        } else {
          localStorage.removeItem("remember_me")
        }

        localStorage.setItem('first_login', response.data[0].first_login)
        localStorage.setItem('user_id', response.data[0].id)
        localStorage.setItem('name', response.data[0].name)
        localStorage.setItem('main_name', response.data[0].name)
        localStorage.setItem('access_token', response_auth.data.access_token)
        localStorage.setItem('email', this.login.email)

        let lastSyndId = localStorage.getItem('last_syndication_id')
        if(lastSyndId == 'null'){
          lastSyndId = null
        }

        localStorage.setItem('syndication_id', lastSyndId ?? response.data[0].syndication_id)
        localStorage.setItem('main_syndication_id', response.data[0].syndication_id)
        this.autoLogOutFunction()
        let fcs_path = localStorage.getItem('fcs_path')
        if (fcs_path) {
          this.$router.push(fcs_path);
        } else {
          this.$router.push('/dashboard');
        }
      } else {
        alert("This portal is not accessable to your role.");
        this.login.email = "";
        this.login.password = "";
      }
      app.processBar = false
    },
  },

};
</script>

<style scoped>
.bg-img {
  /* background-image: url("/images/bg-login.jpg"); */
  background-image: url("/images/login-banner.jpg");
  height: 100vh;
  object-fit:cover;
  /* background-position: center; */
  background-repeat: no-repeat;
  /* background-size: cover; */
  position: relative;
  background-position: left;
	/* margin-left: -200px; */
}

.container {
  position: absolute;
  right: 0;
  padding: 16px;
  background-color: white;
  height: 100%;
  width: 50%;
}

@media only screen and (max-width: 1000px) {
  .container {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.welcome {
  position: absolute;
  /*left: 200px;*/
  width: 50%;
  top: 150px;
  color: #fff;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}

.powered-by {
  position: absolute;
  bottom: 0;
  color: #fff;
  margin: 5px;
  font-weight: bold;
  font-size: 15px;
  left: 200px;
}

.form-area {
  margin-top: 2%;
  width: 60%;
  /* margin: auto; */
  display: flex;
  align-items: center;
  height: calc(100% - 59px) !important;
}

@media only screen and (max-width: 1000px) {
  .form-area {
    width: 80%;
  }
}

.heading-text {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 25px;
  color: #134786;
}

.arr {
  margin-top: 25px;
  color: #BDBDBD !important;
  text-align: center;
}

.motivational-quote {
  color: #fff;
  font-size: 30px;
  font-family: Roboto, sans-serif;
  line-height: 1.5;
  font-style: italic;
  font-weight: normal;
  width: 90%;
  margin: auto;
}

@media only screen and (max-width: 1000px) {
  .logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<style scoped>
#form-textfields .v-input__slot {
  background-color: #edf5ff !important;
}

#remember-me label.v-label.theme--light {
  margin-bottom: 0px !important;
}

#remember-me label.v-label.theme--light {
  font-size: 14px !important;
}
</style>